import { z } from "zod";

import { Template } from "~/tools/template";

import { dashboardWidgetLinks } from "../_dashboard-widget-link";

export const markdownChartSchema = z
	.object({
		plugin: z.object({
			kind: z.literal("Markdown"),
			spec: z
				.object({
					text: z
						.string()
						.trim()
						.catch("")
						.transform((text) => Template<null>(text))
						.optional(),
				})
				.catch({}),
		}),

		links: dashboardWidgetLinks,
	})
	.transform(({ plugin, links }) => ({ ...plugin, links }));

export type MarkdownChart = z.infer<typeof markdownChartSchema>;
